import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsRowModel } from 'src/app/models/widgets/widgets-row.model';
import { WidgetsTextModel } from 'src/app/models/widgets/widgets-text.model';

@Injectable()
export class WidgetsMetadataService {
  _isMetadataAreaActive: boolean = true;
  activeMetadata?: WidgetsAbstract;

  // Observable string sources
  private widgetMaximizedSource = new Subject<WidgetsAbstract>();

  // Observable string streams
  /* eslint-disable */
  widgetMaximizedAnnounced$ = this.widgetMaximizedSource.asObservable();

  get isMetadataAreaActive(): boolean {
    return this._isMetadataAreaActive;
  }

  public set isMetadataAreaActive(val: boolean) {
    this._isMetadataAreaActive = val;
  }
  /* eslint-enable */

  // Service message commands
  showMetadata(widget: WidgetsAbstract) {
    this.activeMetadata = widget;
    this.widgetMaximizedSource.next(widget);
  }

  getMetadata(): WidgetsAbstract | undefined {
    return this.activeMetadata;
  }

  cleanMetadata(): void {
    // this.activeMetadata = new WidgetsRowModel();
    // this.activeMetadata.name = '';
  }
}
